import { render, staticRenderFns } from "./PaginatedResourceController.vue?vue&type=template&id=924b415e"
import script from "./PaginatedResourceController.vue?vue&type=script&lang=js"
export * from "./PaginatedResourceController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports